module.exports = __webpack_public_path__ + "static/media/stamp-50.2d3f7017.svg";